import React,{useEffect, useState} from 'react'
import ReactTable from 'react-table'
import { Row, Col,Container, Card, Input, Button, CardTitle, CardBody } from 'reactstrap'
import AddUserService from '../../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/AddUserService';
import CustomModal from '../../../../Components/Modals/CustomModal';
import AddUserFormPopup from './AddUserFormPopup';
import { connect } from 'react-redux';
import FetchManageUsersService from '../../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/FetchManageUsersService';
import UpdateManageUserStatusService from '../../../../../Service/DashboardServices/UserProfileServices/ProfileDataServices/UpdateManageUserStatusService';


function ManageUsers(props) {
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [searchText, setSearchText] = useState('');
  // const [filteredUsers, setFilteredUsers] = useState([]);

  
  const manageUsersColumn = [
    {
      Header: 'ID',
      accessor: 'id', 
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
  
    {
      Header: 'First Name',
      accessor: 'firstName', 
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: 'Last Name',
      accessor: 'lastName', 
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p className="m-0">{cellInfo.value}</p>
        </div>
      ),
        
      },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p className="m-0 comment-paragraph">{cellInfo.value}</p>
        </div>
      ),
      },
 
    {
      Header: 'Is Active',
      accessor: 'isActive', 
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <input
              style={{cursor:'pointer'}}
              type='checkbox'
              checked={cellInfo.value ? true : false}
              onClick={() => handleUpdateManageUsers(cellInfo.original)}
          />

        </div>
      ),
    },
    
  ];
  useEffect(()=>{
    FetchManageUsersService(props.token).then((res)=>{
      if(res){
        console.log(res)
        setUserData(res.userData);
        // setFilteredUsers(res.userData);
      }
    })
  },[])

  const handleAddUser = (newUser) =>{
    AddUserService(props.token, newUser).then((res)=>{
      if (res ) {
        console.log(res)
        setUserData(res.userData);
        // setFilteredUsers(res.userData);
        setIsAddUserOpen(false);
      }
    });
  };
  
  const handleUpdateManageUsers = (user) => {
    // const updatedUsers = userData.map(u =>
    //   u.id === user.id ? { ...u, isActive: !u.isActive } : u
    // );

    // setUserData(updatedUsers);

    UpdateManageUserStatusService(props.token, { id: user.id }).then((res) => {
      if(res){
        console.log(res)
        console.log(res.userData)
        setUserData(res.userData); 
        // setFilteredUsers(res.userData);
      }
     
    });
  };
  
  const filteredUsersList = userData && userData.filter((row)=>{
    const id=row.id.toString().toLowerCase()
    const firstName= row.firstName.toLowerCase();
    const lastName= row.lastName.toLowerCase();
    const email= row.email.toLowerCase();

    return  firstName.includes(searchText.toLowerCase()) ||
     lastName.includes(searchText.toLowerCase())|| 
     email.includes(searchText.toLowerCase())||
     id.includes(searchText.toString().toLowerCase())
    // issueDescription.includes(query.toLowerCase()) ||
})

  return (
    <Container>
      <Card className='card-of-problemarea mt-3 p-4'>
        <Row>
          <Col md={6}>
      

            <Input
              type='text'
              placeholder='Search Text'
              className='w-50 mt-2 mb-3'
              value={searchText}
              onChange={function(e) { setSearchText(e.target.value); }}
            />
          </Col>
          
          <Col md={6} className="text-md-right">
            <Button
              className="btn-background-color float-md-right"
              onClick={function() { setIsAddUserOpen(true); }}
            >
              Add User
            </Button>
          </Col>

          <Col md={12}>
            <ReactTable
              data={filteredUsersList}
              columns={manageUsersColumn}
              className="-fixed -highlight -striped"
              getTheadProps={function() {
                return {
                  style: {
                    overflowY: "hidden",
                    background: "#B1FA63",
                  },
                };
              }}
              defaultPageSize={50}
              noDataText={"No Data Found."}
            />
          </Col>
        </Row>
      </Card>

      <CustomModal
        header={"Add User"}
        isOpen={isAddUserOpen}
        toggle={function() { setIsAddUserOpen(!isAddUserOpen); }}
        size={"xl"}
        className="curve-popup"
        // footer={
        //   // <Button color={"link"} onClick={function() { setIsAddUserOpen(!isAddUserOpen); }}>
        //   //   Cancel
        //   // </Button>
        // }
      >
        <AddUserFormPopup 
          onSubmit={handleAddUser} 
          closeModal={function() { setIsAddUserOpen(false); }}
        />
      </CustomModal>
    </Container>
  );
}

function mapStateToProps(state) {
  return {
    token: state.loggedUser.token,
    stores: state.accountOverview.landing.adProfiles || [],
  };
}

export default connect(mapStateToProps)(ManageUsers);


 